export default {
    INSERT: 'INSERT',
    EDIT: 'EDIT',
    VIEW: 'VIEW',
};